module.exports = __webpack_public_path__ + "img/collection-engagementRingsModern@2x.829e656.jpg";